(function() {
  'use strict';

  var SAFETY_TIMEOUT = 6000;
  var MIN_LOADER_MS = 100;
  var REQUEST_TIMEOUT = 10000;
  var CFP_TEXT = 'Request Pricing';
  var productDataRequests = {};
  var pendingRequests = [];
  var activeRequests = 0;
  var viewportObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting || !document.contains(entry.target)) return;
      viewportObserver.unobserve(entry.target);
      initWrap(entry.target);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function getProductPath(link) {
    try {
      var url = new URL(link, window.location.origin);
      if (!/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return null;
    }
  }

  function getProductData(productPath) {
    if (!productDataRequests[productPath]) {
      productDataRequests[productPath] = new Promise(function(resolve) {
        pendingRequests.push({ path: productPath, resolve: resolve });
        drainRequests();
      });
    }
    return productDataRequests[productPath];
  }

  function drainRequests() {
    while (activeRequests < 2 && pendingRequests.length) {
      startRequest(pendingRequests.shift());
    }
  }

  function startRequest(request) {
    activeRequests++;
    var controller = 'AbortController' in window ? new AbortController() : null;
    var settled = false;
    var fallback = { vendor: '', callForPrice: false };
    var timer = setTimeout(function() {
      if (controller) controller.abort();
      finish(fallback);
    }, REQUEST_TIMEOUT);

    function finish(data) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      request.resolve(data);
      activeRequests--;
      drainRequests();
    }

    var response;
    try {
      response = fetch(request.path + '?view=card-data', controller ? { signal: controller.signal } : undefined);
    } catch (error) {
      finish(fallback);
      return;
    }
    response
      .then(function(response) {
        if (!response.ok) throw new Error('product request failed');
        return response.json();
      })
      .then(function(data) {
        return { vendor: data.vendor || '', callForPrice: data.call_for_price === true };
      })
      .then(finish)
      .catch(function() { finish(fallback); });
  }

  function applyCallForPrice(card) {
    var priceEl = card.querySelector('.rebuy-product-price') || card.querySelector('.rebuy-money');
    if (!priceEl || (priceEl.getAttribute('data-rec-cfp') === '1' && priceEl.textContent === CFP_TEXT)) return;
    priceEl.__recOriginalPrice = priceEl.innerHTML;
    priceEl.setAttribute('data-rec-cfp', '1');
    priceEl.classList.add('rec-cfp');
    priceEl.textContent = CFP_TEXT;
  }

  function applyProductData(card, title, data) {
    if (!document.contains(card)) return;

    if (data.vendor && document.contains(title) && !card.querySelector('.rebuy-product-vendor')) {
      var vendorElement = document.createElement('p');
      vendorElement.className = 'rebuy-product-vendor';
      vendorElement.setAttribute('data-rec-vendor', '1');
      vendorElement.textContent = 'By ' + data.vendor;
      title.insertAdjacentElement('afterend', vendorElement);
    }

    if (data.callForPrice) applyCallForPrice(card);
  }

  function clearProductData(card) {
    var vendor = card.querySelector('[data-rec-vendor]');
    if (vendor) vendor.remove();
    var priceEl = card.querySelector('[data-rec-cfp]');
    if (priceEl) {
      if (priceEl.textContent === CFP_TEXT && typeof priceEl.__recOriginalPrice === 'string') {
        priceEl.innerHTML = priceEl.__recOriginalPrice;
      }
      priceEl.removeAttribute('data-rec-cfp');
      priceEl.classList.remove('rec-cfp');
      delete priceEl.__recOriginalPrice;
    }
  }

  function cardSource(card) {
    var title = card.querySelector('.rebuy-product-title');
    var link = title && (title.querySelector('a') || card.querySelector('.rebuy-product-media a'));
    return { title: title, path: link && getProductPath(link.href) };
  }

  function enrichRebuyCard(card, title, productPath) {
    if (card.__recProductPath !== productPath) {
      clearProductData(card);
      card.__recProductPath = productPath;
      card.__recProductData = null;
      card.__recProductDataPending = false;
    }
    if (card.__recProductData) {
      applyProductData(card, title, card.__recProductData);
      return;
    }
    if (card.__recProductDataPending) return;

    card.__recProductDataPending = true;
    getProductData(productPath).then(function(data) {
      var current = cardSource(card);
      if (card.__recProductPath !== productPath || current.path !== productPath) return;
      card.__recProductDataPending = false;
      card.__recProductData = data;
      applyProductData(card, current.title, data);
    });
  }

  function enrichRebuyCards(wrap) {
    if (!wrap.querySelector('[data-rebuy-id]')) return;

    var titles = wrap.querySelectorAll('.rebuy-product-title');
    for (var i = 0; i < titles.length; i++) {
      var title = titles[i];
      var card = title.closest('.rebuy-product-block');
      var productPath = card && cardSource(card).path;

      if (!card || !productPath) continue;
      enrichRebuyCard(card, title, productPath);
    }
  }

  function observeRebuy(wrap) {
    if (wrap.__recRebuyObserver) return;

    var observer = new MutationObserver(function(mutations) {
      var isOnlyOurTags = true;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'attributes' || mutations[i].type === 'characterData') {
          isOnlyOurTags = false;
          break;
        }
        if (mutations[i].removedNodes.length) isOnlyOurTags = false;
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && !added[j].classList.contains('rebuy-product-vendor')) {
            isOnlyOurTags = false;
            break;
          }
        }
        if (!isOnlyOurTags) break;
      }
      
      if (isOnlyOurTags) return;

      if (wrap.__recFrame) return;
      wrap.__recFrame = requestAnimationFrame(function() {
        wrap.__recFrame = null;
        if (!document.contains(wrap)) return;
        if (wrap.__recInit) {
          enrichRebuyCards(wrap);
          reconcileEmpty(wrap);
        } else if (hasVisibleProducts(wrap)) {
          wrap.classList.remove('is-empty');
        }
      });
    });
    
    observer.observe(wrap, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
    wrap.__recRebuyObserver = observer;

  }


  function isWrapReady(wrap) {
    return !!(
      wrap.querySelector('.rebuy-widget-content') ||
      wrap.querySelector('.flickity-enabled') ||
      wrap.querySelector('.ProductList--grid') ||
      wrap.querySelector('.ProductList--carousel .Carousel__Cell')
    );
  }

  function hasVisibleProducts(wrap) {
    var rebuyWidget = wrap.querySelector('[data-rebuy-id]');
    if (rebuyWidget) {
      return !!rebuyWidget.querySelector('.rebuy-product-block');
    }
    return !!wrap.querySelector('.Carousel__Cell, .Grid__Cell');
  }

  function reconcileEmpty(wrap) {
    if (hasVisibleProducts(wrap)) {
      var wasEmpty = wrap.classList.contains('is-empty');
      wrap.classList.remove('is-empty');

      if (wasEmpty) {
        wrap.__recResizeFrame = requestAnimationFrame(function() {
          wrap.__recResizeFrame = null;
          if (!document.contains(wrap)) return;
          window.dispatchEvent(new Event('resize'));
        });
      }
    } else {
      wrap.classList.add('is-empty');
    }
  }

  function reveal(wrap) {
    var held = Date.now() - (wrap.__recStart || 0);
    var wait = Math.max(0, MIN_LOADER_MS - held);
    wrap.__recRevealTimer = setTimeout(function() {
      wrap.__recRevealTimer = null;
      if (document.contains(wrap)) wrap.classList.add('is-loaded');
    }, wait);
  }

  function markLoaded(wrap) {
    if (wrap.__recLoaded) return;
    wrap.__recLoaded = true;
    enrichRebuyCards(wrap);
    observeRebuy(wrap);

    reconcileEmpty(wrap);
    reveal(wrap);

    if (wrap.__recObserver) { wrap.__recObserver.disconnect(); wrap.__recObserver = null; }
    if (wrap.__recTimer) { clearTimeout(wrap.__recTimer); wrap.__recTimer = null; }
  }

  function initWrap(wrap) {
    if (wrap.__recInit) return;
    wrap.__recInit = true;
    wrap.__recStart = Date.now();

    if (isWrapReady(wrap)) {
      markLoaded(wrap);
      return;
    }

    var observer = new MutationObserver(function() {
      if (isWrapReady(wrap)) markLoaded(wrap);
    });
    
    observer.observe(wrap, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    wrap.__recObserver = observer;

    wrap.__recTimer = setTimeout(function() {
      markLoaded(wrap);
    }, SAFETY_TIMEOUT);
  }

  function scan(root) {
    var scope = root || document;
    if (scope.nodeType === 1 && scope.matches('.rec-wrap[data-rec-loader]')) queueWrap(scope);
    var wraps = scope.querySelectorAll ? scope.querySelectorAll('.rec-wrap[data-rec-loader]') : [];
    for (var i = 0; i < wraps.length; i++) queueWrap(wraps[i]);
  }

  function queueWrap(wrap) {
    if (wrap.__recQueued) return;
    wrap.__recQueued = true;
    observeRebuy(wrap);
    if (hasVisibleProducts(wrap)) wrap.classList.remove('is-empty');
    if (viewportObserver) viewportObserver.observe(wrap);
    else initWrap(wrap);
  }

  function cleanup(root) {
    var wraps = root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll('.rec-wrap[data-rec-loader]')) : [];
    if (root.matches && root.matches('.rec-wrap[data-rec-loader]')) wraps.push(root);
    wraps.forEach(function(wrap) {
      if (document.contains(wrap)) return;
      if (viewportObserver) viewportObserver.unobserve(wrap);
      if (wrap.__recObserver) wrap.__recObserver.disconnect();
      if (wrap.__recRebuyObserver) wrap.__recRebuyObserver.disconnect();
      clearTimeout(wrap.__recTimer);
      clearTimeout(wrap.__recRevealTimer);
      cancelAnimationFrame(wrap.__recFrame);
      cancelAnimationFrame(wrap.__recResizeFrame);
      wrap.__recQueued = wrap.__recInit = wrap.__recLoaded = false;
      wrap.__recObserver = wrap.__recRebuyObserver = wrap.__recFrame = null;
      wrap.__recTimer = wrap.__recRevealTimer = wrap.__recResizeFrame = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function(event) { scan(event.target); });

  var root = document.body || document.documentElement;
  if (root && 'MutationObserver' in window) {
    var lateObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && added[j].parentElement && !added[j].parentElement.closest('.rec-wrap[data-rec-loader]')) scan(added[j]);
        }
        var removed = mutations[i].removedNodes;
        for (var k = 0; k < removed.length; k++) {
          if (removed[k].nodeType === 1) cleanup(removed[k]);
        }
      }
    });
    lateObserver.observe(root, { childList: true, subtree: true });
  }
})();
